// @flow

import React, { type Node } from 'react';
import { useIncomingPayment, isRetry, getCountry } from '@tectonics/prs/incoming-payment';
import { useFormStatusContext } from '@tectonics/prs/form-status';

import { ErrorDisplay } from '../../molecules';
import { Empty } from '../../atoms';

export function RetryMessageDisplay(): Node {
  const incomingPayment = useIncomingPayment();
  const [formStatus] = useFormStatusContext();

  if (incomingPayment.status === 'OP' && isRetry(incomingPayment) && formStatus === 'sent') {
    return <ErrorDisplayByCountry data-test-id="retry-message" />;
  }

  return <Empty />;
}

function ErrorDisplayByCountry(props: any): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch(country) {
    case 'br':
      return (
        <ErrorDisplay {...props}>
          Seu pagamento não foi aprovado.<br />
          Revise seus dados ou escolha outro método de pagamento.
        </ErrorDisplay>
      );

    case 'mx':
    case 'co':
      return (
        <ErrorDisplay {...props}>
          Su pago no fue aprobado.<br/>
          Revise sus datos o elija otro método de pago.
        </ErrorDisplay>
      );

    default:
      throw new Error(`Retry message not mapped for country ${country}`);
  }
}
